import React from 'react';
import { Dialog } from '../../Dialog';
import { StandardClausesContent } from './StandardClausesContext';
import { StandardClausesDialogProps } from './types';

export const StandardClausesDialog: React.FC<StandardClausesDialogProps> = ({
	openModal,
	handleClose,
	handleSave,
	standardCauses,
	mountNode,
}) => {
	const [isOpen, setIsOpen] = React.useState(false);

	React.useEffect(() => {
		setIsOpen(openModal);
	}, [openModal]);

	const onHandleSave = React.useCallback(
		(txt: string) => {
			handleSave(txt);
		},
		[handleSave],
	);

	const spanRef = React.useRef(null);

	return (
		<>
			<Dialog
				data-testid="epods-standard-clauses-dialog"
				closeable={false}
				isOpen={isOpen}
				mountNode={mountNode || (spanRef.current as any)}
				hideHeader={true}
				overrides={{
					Dialog: {
						style: () => {
							return { height: '85vh', overflow: 'auto', minHeight: 'fit-content', margin: '8px' };
						},
					},
				}}
			>
				<StandardClausesContent
					handleClose={handleClose}
					handleSave={onHandleSave}
					standardCausesData={standardCauses}
				/>
			</Dialog>
			<span ref={spanRef}></span>
		</>
	);
};
